import { render, staticRenderFns } from "./RejectFileModal.vue?vue&type=template&id=14046100"
import script from "./RejectFileModal.vue?vue&type=script&lang=js"
export * from "./RejectFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports